/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const borderColor = '#00519C';

const styles = StyleSheet.create({
	tableContainer: {
		marginTop: 24,
		borderWidth: 1,
		borderColor: borderColor,
	},

	container: {
		flexDirection: 'row',
		backgroundColor: '#00519C',
		color: '#fff',
		minHeight: 28,
		alignItems: 'center',
	},

	headerCell: {
		fontSize: 9,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: '#ffffff',
		justifyContent: 'center',
		display: 'flex',
	},

	id: {
		width: '6%',
		textAlign: 'center',
	},

	name: {
		width: '14%',
		textAlign: 'left',
	},

	user: {
		width: '14%',
		textAlign: 'left',
	},

	assignedDate: {
		width: '12%',
		textAlign: 'center',
	},

	endDate: {
		width: '12%',
		textAlign: 'center',
	},

	description: {
		width: '18%',
		textAlign: 'left',
	},

	remarks: {
		width: '14%',
		textAlign: 'left',
	},

	status: {
		width: '10%',
		textAlign: 'center',
		borderRightWidth: 0,
	},
});

const paginate = (array, perPage) => {
	const pages = [];

	for (let i = 0; i < array.length; i += perPage) {
		pages.push(array.slice(i, i + perPage));
	}

	return pages;
};

const InvoiceItemsTable = (props) => {
	const itemsPerPage = 10;
	const pages = paginate(props.invoice || [], itemsPerPage);

	return (
		<>
			{pages.map((pageData, pageIndex) => (
				<React.Fragment key={pageIndex}>
					
					{/* break only after first page */}
					{pageIndex > 0 && <View break />}

					<View wrap>
						{/* Header */}
						<View style={styles.container}>
							<Text style={[styles.headerCell, styles.id]}>
								ID
							</Text>

							<Text style={[styles.headerCell, styles.name]}>
								Name
							</Text>

							<Text style={[styles.headerCell, styles.user]}>
								User
							</Text>

							<Text style={[styles.headerCell, styles.assignedDate]}>
								Assigned Date
							</Text>

							<Text style={[styles.headerCell, styles.endDate]}>
								End Date
							</Text>

							<Text style={[styles.headerCell, styles.description]}>
								Description
							</Text>

							<Text style={[styles.headerCell, styles.remarks]}>
								Remarks
							</Text>

							<Text style={[styles.headerCell, styles.status]}>
								Status
							</Text>
						</View>

						{/* Rows */}
						<InvoiceTableRow data={pageData} />
					</View>
				</React.Fragment>
			))}
		</>
	);
};

export default InvoiceItemsTable;